module.exports = __webpack_public_path__ + "static/media/nip_inward.5aebab2d.svg";